import React from 'react';
import { useLanguage } from '../LanguageContext';
import { SURPRISE_POOL } from '../data/characters';
import { Check, Shuffle, Sparkles } from 'lucide-react';

// The "Surprise Me" tile. Shared by the booth's character picker and the Gallery
// so both entry points look and read the same; the roll itself happens in
// Photobooth.jsx at generate time.
export default function SurpriseMeTile({ selected = false, onClick }) {
  const { language, isRTL } = useLanguage();

  return (
    <button
      type="button"
      onClick={onClick}
      className={`w-full rounded-2xl p-4 flex items-center gap-4 transition-all border-2 ${
        selected
          ? 'border-amber-400 bg-gradient-to-r from-amber-500/20 to-pink-500/20 shadow-lg shadow-amber-500/10'
          : 'border-slate-700 bg-gradient-to-r from-violet-600/10 to-pink-600/10 hover:border-amber-400/60'
      }`}
    >
      <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-amber-400 to-pink-500 flex items-center justify-center shrink-0">
        <Shuffle className="w-7 h-7 text-white" />
      </div>
      <div className={`flex-1 min-w-0 ${isRTL ? 'text-right' : 'text-left'}`}>
        <p className="text-white font-bold text-lg flex items-center gap-2">
          {language === 'he' ? 'תפתיע אותי' : 'Surprise Me'}
          <Sparkles className="w-4 h-4 text-amber-400 shrink-0" />
        </p>
        <p className="text-sm text-slate-400">
          {language === 'he'
            ? `דמות אקראית מתוך ${SURPRISE_POOL.length} — כולל דמויות שלא מופיעות ברשימה`
            : `A random character from ${SURPRISE_POOL.length} — including ones not in the list`}
        </p>
      </div>
      {selected && (
        <Check className="w-6 h-6 text-amber-400 shrink-0" />
      )}
    </button>
  );
}
